module.exports = __webpack_public_path__ + "img/referral-program-setup.03d1e07d.jpg";